import React, {useState} from 'react'
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";


export default function LoginForm(props) {
    function handleSubmit(event) {
        event.preventDefault();

        let payload = {
           user: user,
           pass: pass,
        }

        setLoginString("Logging in...")
        fetch("/login", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        })
            .then(response => {
                if (response.status === 200){
                    setLoginString("Loading")
                    document.location.reload()
                }else{
                    setLoginString("Login")
                }
            });
    }

    const [user, setUser] = useState("");
    const [pass, setPassword] = useState("");
    const [loginString, setLoginString] = useState("Login");

    function validateForm() {
        return user.length > 0 && pass.length > 0;
    }

    return (
        <Container style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
        }}
        >
            <Row className="justify-content-md-center">
                <Col xs lg="6">
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label className="d-none d-sm-block">User name</Form.Label>
                            <Form.Control type="user" placeholder="Username" value={user}
                                          onChange={e => setUser(e.target.value)}/>
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword">
                            <Form.Label className="d-none d-sm-block">Password</Form.Label>
                            <Form.Control type="password" placeholder="Password" value={pass}
                                          onChange={e => setPassword(e.target.value)}/>
                        </Form.Group>
                        <Container className="text-center">
                            <Button className="" variant={validateForm() ? "success" : "outline-secondary"}
                                    disabled={!validateForm()} type="submit">
                                {loginString}
                            </Button>
                        </Container>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}
